import { MutableRefObject } from 'react';

import { Form } from '@kanda-libs/ks-component-ts';
import {
  ModalContainer,
  ModalLayoutCenter,
} from '@kanda-libs/ks-design-library';
import { Company } from '@kanda-libs/ks-frontend-services';

import APR from './APR';
import useFinanceCalculatorLinkModalForm from './useFinanceCalculatorLinkModal';

import { FINANCE_CALCULATOR_MODAL_ID } from '../constants';

const FinanceCalculatorLinkModal: React.FunctionComponent = function () {
  const { form, aprs, url, onClick } = useFinanceCalculatorLinkModalForm();

  return (
    <ModalContainer id={FINANCE_CALCULATOR_MODAL_ID} opacity={40}>
      {({ id, ref, handleClose }) => (
        <ModalLayoutCenter
          id={id}
          onClose={handleClose}
          ref={ref as MutableRefObject<HTMLDivElement>}
          className="w-11/12 max-w-180"
        >
          <Form
            form={form}
            onSubmit={() => {}}
            id="company-finance-calculator-form"
          >
            <p className="text-16-24-em mb-4">Configure Calculator</p>
            <p className="text-14-22 text-neutral-700 mb-2">
              Untick APRs to exclude them from the calculator
            </p>
            <div className="flex flex-row flex-wrap gap-x-2 gap-y-1 mb-3">
              {aprs.map((apr) => (
                <APR apr={apr} />
              ))}
            </div>
            <p className="text-14-22-em text-neutral-700 mb-2">
              URL (click to copy)
            </p>
            <button
              type="button"
              onClick={onClick}
              className="p-2 bg-neutral-100 rounded-lg text-14-22 break-all text-left"
            >
              {url}
            </button>
          </Form>
        </ModalLayoutCenter>
      )}
    </ModalContainer>
  );
};

export default FinanceCalculatorLinkModal;
